export default __webpack_public_path__ + "static/media/phapoom_img2.9272aa7b.webp";